import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import logo from '../assets/images/z1logo.png';
import esewa from '../assets/images/payment/esewa.png';
import khalti from '../assets/images/payment/khalti.png';
import bankTransfer from '../assets/images/payment/bank_transfer.png';
import masterCard from '../assets/images/payment/master_card.png';

const Footer = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle subscription logic here
    console.log('Subscribing email:', email);
    alert('Thank you for subscribing!');
    setEmail('');
  };

  return (
    <>
    <style>
         {`
          /* ===== FOOTER BASE ===== */
      .footer-area.footer-eleven {
        background-color: #4169E1;
        color: #cbd5e1;
        font-size: 14px;
      }

      .footer-top {
        padding: 60px 0 30px;
      }

      /* ===== ABOUT SECTION ===== */
      .footer-widget.f-about p {
        margin-top: 15px;
        line-height: 1.7;
        font-size: 16px;
        color: #ffffff;
        font-weight: 600;
        text-align: justify;
      }

      .footer-widget .logo img {
        margin-bottom: 5px;
        position: relative;
      }

      /* ===== LINKS ===== */
      .footer-widget h5 {
        color: #ffffff;
        font-size: 20px;
        margin-bottom: 18px;
        font-weight: 800;
      }

      .footer-widget.f-link ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .footer-widget.f-link ul li {
        margin-bottom: 10px;
      }

      .footer-widget.f-link ul li a {
        color: #ffffff;
        font-size: 18px;
        text-decoration: none;
        transition: color 0.3s ease;
      }

      .footer-widget.f-link ul li a:hover {
        color: #38bdf8;
      }

      /* ===== PAYMENT METHODS ===== */
      .payment-methods img {
        background: #ffffff;
        border-radius: 6px;
        transition: transform 0.3s ease;
      }

      .payment-methods img:hover {
        transform: translateY(-3px);
      }

      /* ===== COPYRIGHT ===== */
      .copyright-content {
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        padding-top: 15px;
      }

      .copyright-text {
        font-size: 13px;
        color: #94a3b8;
        margin: 0;
      }

      .copyright-text span {
        color: #e5e7eb;
        font-weight: 500;
      }

      /* ===== MOBILE OPTIMIZATION ===== */
      @media (max-width: 768px) {
        .footer-widget {
          text-align: center;
        }

        .footer-widget.f-link ul li {
          display: inline-block;
          margin: 0 10px 10px;
        }

        .payment-methods img {
          margin-bottom: 10px;
        }
      }
         `}
       </style>
   
    <footer className="footer-area footer-eleven">
      <div className="footer-top">
        <div className="container">
          <div className="inner-content">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="footer-widget f-about">
                  <div className="logo">
                    <a href="/">
                      <img src={logo} style={{ height: '100px', width: '100px' }} alt="Z1 Technology Logo" className="img-fluid" />
                    </a>
                  </div>
                  <p>
                    Founded in 2022 by experienced IT professionals with roots since 2002, Z1 Technology delivers reliable software solutions in Nepal. Our flagship products Purnima ERP and Z1 Tracker GPS system are widely used by government offices, cooperatives, hospitals, and business houses across Nepal.
                  </p>
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-12">
                <div className="footer-widget f-link">
                  <h5>Solutions</h5>
                  <ul>
                    <li><a href="#services">ERP Solutions</a></li>
                    <li><a href="#services">GPS Tracking</a></li>
                    <li><a href="#services">Analytics</a></li>
                    <li><a href="#services">Enterprise Systems</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-2 col-md-6 col-12">
                <div className="footer-widget f-link">
                  <h5>Support</h5>
                  <ul>
                    <li><a href="" onClick={() => navigate("/terms-conditions")}>Terms & Conditions</a></li>
                    <li><a href="" onClick={() => navigate("/support-policy")}>Support Policy</a></li>
                    <li><a href="" onClick={() => navigate("/return-policy")}>Return Policy</a></li>
                    <li><a href="" onClick={() => navigate("/privacy-policy")}>Privacy Policy</a></li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12">
                <div className="footer-widget newsletter">
                  <h5>Subscribe</h5>
                  <p style={{fontSize: "14px", fontWeight: "800", color: 'whitesmoke'}}>Subscribe to our site for the latest updates !</p>
                  <form onSubmit={handleSubscribe} className="newsletter-form">
                    <input
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <div className="button">
                      <button type="submit" className="sub-btn">
                        <i className="lni lni-envelope"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="row mt-4">
                  <div className="col-12 text-center">
                    <div className="payment-methods">
                      <img src={esewa} alt="esewa" style={{height: "50px", width: "60px", marginLeft: "8px", padding: "10px"}}/>
                      <img src={khalti} alt="khalti"  style={{height: "50px", width: "60px", marginLeft: "8px", padding: "10px"}} />
                      <img src={bankTransfer} alt="banktransfer"  style={{height: "50px", width: "60px", marginLeft: "8px", padding: "10px"}} />
                      <img src={masterCard} alt="master_card"  style={{height: "50px", width: "60px", marginLeft: "8px", padding: "10px"}} />
                    </div>
                  </div>
                </div> 
                <div className="row mt-4 mb-0">
                  <div className="col-12 text-center">
                    <div className='copyright-content'>
                     <p className="copyright-text">
                    <span>© 2024 Zone Technology & Trade Pvt. Ltd.</span> All rights reserved.
                    </p>
                    </div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
     </>
  );
};

export default Footer;
